module.exports = __webpack_public_path__ + "static/img/Marcus_Bontempelli_desktop.7f1c2a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Marcus_Bontempelli_desktop.jpg
// module id = 1xoU
// module chunks = 0